import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon, MDBFormInline  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip ,PageHeader, Avatar  } from 'antd';
import Swal from 'sweetalert2'
import { URL,api } from '../../api';
import ban from '../../img/math.png'

export default class Modaladdexpertbn extends Component {
    constructor(props) {
        super(props);
                this.state = {
                modal: false,

                send_id :'1', //ผู้ลงทะเบียน
                send_type : '', //ประเภท

                name_expertbn : '', //ผู้นำเสนอ
                username_expertbn : '', //ผู้นำเสนอ
                password_expertbn : '', //ผู้นำเสนอ
                affiliation_expertbn : '', //ผู้นำเสนอ
                expertise_expertbn : '', //ผู้นำเสนอ
                tel_expertbn : '', //ผู้นำเสนอ
                adminaddbybn : '', //ผู้นำเสนอ
                iduserbn:'',
                presentype:[],
                presentypeid:'',
                }

   
              


           
                this.toggle = this.toggle.bind(this);
                this.handleSubmit = this.handleSubmit.bind(this);

               
                this.handleChangesend_namebn = this.handleChangesend_namebn.bind(this);
                this.handleChangesend_usernamebn = this.handleChangesend_usernamebn.bind(this);
                this.handleChangesend_passwordbn = this.handleChangesend_passwordbn.bind(this);
                this.handleChangesend_affiliationbn = this.handleChangesend_affiliationbn.bind(this);
                this.handleChangesend_expertisebn = this.handleChangesend_expertisebn.bind(this);
                this.handleChangesend_telbn = this.handleChangesend_telbn.bind(this);
                this.presentypelist = this.presentypelist.bind(this);
                this.handleChangesend_presentype = this.handleChangesend_presentype.bind(this);



             
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
  this.presentypelist();
}


presentypelist(){
   setTimeout(() => {
       //จังหวัด
       api.get('registercon/selecttpresentationtype')
       // Axios.get('http://localhost/phpapi/selectamphures.php?PROVINCE_ID='+u.value)
       .then(res => {
    
       const data = res.data
       const optionsam = data.map(a => ({
           "value" : a.presentype_id,
           "label" : a.presentype_name
         }))
         this.setState({ presentype: optionsam})
       }) 
     }, 0);
  }

  handleChangesend_presentype(event) {  
    console.log(event)
      this.setState({presentypeid: event});  
    }




 componentDidMount() {
       const { iduser } = this.props.iduser
    //   console.log(id_send);
       this.setState({ iduserbn:this.props.iduser})
    //   setTimeout(() => {
    //     //ภายใน
    //      Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
    //     .then(res => {
    //       console.log(res);
    //     //  this.setState({ bankname: res.data, loading: false })
    //       this.setState({ Expert: res.data})
    //     }) 

    //   }, 0);

  }

//   getExpert() {
//     setTimeout(() => {
//       //ภายใน
//        Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
//       .then(res => {
//         console.log(res);
//       //  this.setState({ bankname: res.data, loading: false })
//         this.setState({ Expert: res.data})
//       }) 
//     }, 0);

// }


handleChangesend_namebn(event) {    this.setState({name_expertbn: event.target.value});  }
handleChangesend_usernamebn(event) {    this.setState({username_expertbn: event.target.value});  }
handleChangesend_passwordbn(event) {    this.setState({password_expertbn: event.target.value});  }
handleChangesend_affiliationbn(event) {    this.setState({affiliation_expertbn: event.target.value});  }
handleChangesend_expertisebn(event) {    this.setState({expertise_expertbn: event.target.value});  }
handleChangesend_telbn(event) {    this.setState({tel_expertbn: event.target.value});  }


  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
    //  datafrm.append("send_id", this.props.iduser);
      datafrm.append("name_expertbn", this.state.name_expertbn);
      datafrm.append("username_expertbn", this.state.username_expertbn);
      datafrm.append("password_expertbn", this.state.password_expertbn);
      datafrm.append("affiliation_expertbn", this.state.affiliation_expertbn);
      datafrm.append("expertise_expertbn", this.state.expertise_expertbn);
      datafrm.append("tel_expertbn", this.state.tel_expertbn);
      datafrm.append("iduserbn", this.state.iduserbn);
      datafrm.append("presentypeid", this.state.presentypeid);
     //  datafrm.append("agree_type", this.state.radio);
     //  datafrm.append("send_uploadeword12", this.state.send_uploadeword12);
     //  datafrm.append("send_uploadepdf12", this.state.send_uploadepdf12);
     // datafrm.append("send_date1", dates);

     //  datafrm.append("send_statuspay", this.state.send_statuspay);
     //  datafrm.append("stapat", this.state.stapat);

    api.post("registercon/Insertexpertbn",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
    console.warn(res);
     console.log("response: ", res)
     if (res.data.length !== 0) {
      // this.showitem = true;
       console.log(res)
       console.log(res.data.length) 
    }else{
     // window.location.href = '/'
    }


    if (res.data = '200') {
     // message.success("อัพโหลไฟล์สำเร็จ")
    //  this.setState({ id_send: ""})
     // window.location.href = '/adminfaculty'
     Swal.fire({
      title: 'เพิ่มบรรณาธิการสำเร็จ',
      text: "Successfully added editor",
      icon: 'success',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ตกลง'
    }).then((result) => {
      if (result.isConfirmed) {
        // Swal.fire(
        //   'Deleted!',
        //   'Your file has been deleted.',
        //   'success'
        // )
        this.props.list();
        this.toggle()
      }
    })
    
    }else{
      message.error("อัพโหลไฟล์ไม่สำเร็จ!")
    }

  })



}, 2000);

//window.location.href = '/adminfaculty'
//this.props.updateat();
//this.getExpert()

  }

  

    render() {
        
        //   console.log(this.state.send_type)
        //   console.log(this.state.major_precent)
        //   console.log(this.state.name_present)
        //   console.log(this.state.send_name)
        //   console.log(this.state.send_uploadeword1)
        //   console.log(this.state.send_uploadepdf1)
        //   console.log(this.state.radio)


        return (
          
            <MDBContainer className='text-left'>
           <div className='text-center'><MDBBtn color="deep-purple" onClick={this.toggle}><MDBIcon icon="plus-square" />  เพิ่มข้อมูลบรรณาธิการ</MDBBtn></div> 

            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
              <MDBModalHeader toggle={this.toggle}> <Avatar src="https://cdn-icons-png.flaticon.com/512/5231/5231019.png" /> เพิ่มข้อมูลบรรณาธิการ</MDBModalHeader>
              <MDBModalBody>
              <img src={ban} className="rounded mx-auto " alt="aligment" />
              <div>
              <br/>
           
                    

                            <div className="mb-2">
                           <label className="black-text"><strong>ชื่อบรรณาธิการ</strong></label>
                           <input className="form-control" onChange={this.handleChangesend_namebn} name="name"
                                    value={this.state.name_expertbn} placeholder="กรุณาระบุชื่อบรรณาธิการ" required />
                            </div>
                  

                           <div className="mb-2">
                           <label className="black-text"><strong>Username</strong></label>
                           <input className="form-control" onChange={this.handleChangesend_usernamebn} name="username"
                                    value={this.state.username_expertbn} placeholder="กรุณาระบุ Username" required />
                            </div>

                            <div className="mb-2">
                           <label className="black-text"><strong>Password</strong></label>
                           <input className="form-control" onChange={this.handleChangesend_passwordbn} name="password"
                                    value={this.state.password_expertbn} placeholder="กรุณาระบุ Password" required />
                            </div>

                            <div className="mb-2">
                           <label className="black-text"><strong>สังกัด/หน่วยงาน</strong></label>
                           <input className="form-control" onChange={this.handleChangesend_affiliationbn} name="affiliation"
                                    value={this.state.affiliation_expertbn} placeholder="กรุณาระบุสังกัด/หน่วยงาน" required />
                            </div>

                          <div className="mb-2">
                           <label className="black-text"><strong>ความเชียวชาญ</strong></label>
                           <input className="form-control" onChange={this.handleChangesend_expertisebn} name="expertise"
                                    value={this.state.expertise_expertbn} placeholder="กรุณาระบุความเชียวชาญ" required />
                          </div>

                          <div className="mb-2">
                           <label className="black-text"><strong>เบอร์โทร</strong></label>
                           <input className="form-control" onChange={this.handleChangesend_telbn} name="tel"
                                    value={this.state.tel_expertbn} placeholder="กรุณาระบุเบอร์โทร" required />
                          </div>

                          <div className="mb-2">
                            <label className="black-text">ประเภทที่ดูแล</label>
                            <Select placeholder="กรุณาระบุ ประเภทที่ดูแล"  className="browser-default custom-select " options={this.state.presentype}  onChange={this.handleChangesend_presentype.bind(this)} required/><br/>
                          </div>




                 
              </div>
              
              </MDBModalBody>
              <MDBModalFooter>
                 <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
               
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
          
        )
    }
}
